/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationNeedsSubscribersQuery = gql`
  query GetSimulationNeedsSubscribersQuery {
    getSimulationNeedsSubscribers_simulation_needs {
      subscribers {
 birthDate  
id  
index  
firstName  
lastName  
socialSecurities {
 regime  
} 
}
    }
  }
`;

export default GetSimulationNeedsSubscribersQuery;
